import { LoggerContext } from "@scrile/streaming-client/build/Logger";
import CallsLogger from "@/modules/callsLogger";

export default function useStreamLogger(namespace: string, getInitialContext: () => LoggerContext) {
  const businessLogicLog = async (message: string, context?: LoggerContext): Promise<void> => {
    await CallsLogger.collectLogs(`${namespace} - ${message}`, {
      ...getInitialContext(),
      ...context,
      streaming: true,
    });
  };
  const collectErrorLogs = async (message: string, error: unknown, context?: LoggerContext): Promise<void> => {
    await CallsLogger.collectLogs(`${namespace}:ERROR - ${message}`, {
      ...getInitialContext(),
      ...context,
      streaming: true,
      error,
    });
  };
  const debug = async (message: string, context?: LoggerContext): Promise<void> => {
    await CallsLogger.collectLogs(message, { streaming: true, ...context });
  };

  return {
    businessLogicLog,
    collectErrorLogs,
    debug,
  };
}
